// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ad6451b9","732":"d7ff86ac","977":"00d553e1"}[chunkId] + ".chunk.js";
};